import Birthday from './Birthday'
import Locality from './Locality'
import Email from './Email'
import Networking from './Networking'
import ExperienceTime from './ExperienceTime'
import Image from "./Image"
import Link from "./Link"

export default function ProfileHeaderPresentation({ identity, careers, style, networking }) {
    const presentation = [
        identity.lastname.toUpperCase(),
        identity.firstname
    ].join(" ")

    return (
        <div className="presentation" style={ style.identity || {}}>
            <h1>
                <span>{ presentation }</span>
                <Link
                    href="website"
                    params={ {url: networking && networking.website || ""} }
                    target="_blank"
                >
                    <i alt="website"><Image src="website" alt="website" /></i>
                </Link>
            </h1>
            <div className="wrapper">
                <h5 style={ style["identity.birthday"] || {} }>
                    <Birthday />
                </h5>
                <h5 className="experience_time">
                    <ExperienceTime careers={ careers } />
                </h5>
                <h5 className="locality">
                    <Locality />
                </h5>
                <h5 className="email">
                    <Email 
                        email={ identity.email }
                    />
                </h5>
                <Networking 
                    identity={ identity }
                    networking={ networking }
                />
            </div>
        </div>
    )
}